const busquedadedocumentos = {
    GetDocumentosContenidosPaginaWeb: 'SICPO/BusquedaDeDocumentos/GetDocumentosContenidos'
}

export default busquedadedocumentos;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/busquedaDeDocumentos/busquedadedocumentos.js
// module id = null
// module chunks = 